<template>
  <div class="app-header text-17px"
  :class="{'fixed top-0 inset-x-0 z-20 bg-white shadow' : isSticky && isHomeRoute}">
    <div class="main-container flex items-center justify-between">
      <div class="flex items-center">
        <a :href="baseURL"><AppLogo /></a>
        <ul class="hidden lg:flex ml-12 lg:text-sm lg2:text-base">
          <li class="pr-2 lg2:pr-6 ">
            <a :href="`${baseURL}`">Expert Sourcing</a>
          </li>
          <li class="px-2 lg2:px-6">
            <a :href="`${baseURL}/contract-manufacturing`">Contract Manufacturing</a>
          </li>
          <li class="px-2 lg2:px-6">
            <router-link to="/" :class="isProfilePage ? 'home-screen' : ''">Buy</router-link>
          </li>
          <li class="px-2 lg2:px-6">
            <a :href="`${baseURL}/finance-page`">Financing</a>
          </li>
          <li class="pl-2 lg2:pl-6 relative">
            <div
              @mouseenter="showAboutOptions = true"
              @mouseleave="showAboutOptions = false"
              class="flex"
            >
              <span>About Us</span>
              <img src="@/assets/icons/chevronDown.svg" class="pl-2 w-5">
              <transition name="slide-down">
                <div
                  v-if="showAboutOptions"
                  class="absolute z-20 left-0 top-full slide-down pt-2 px-3"
                >
                  <ul class="px-3 py-2 w-32 border rounded-lg bg-white">
                    <li>
                      <a :href="`${baseURL}/about-us/`" class="inline-block py-1 hover:text-green">
                        Our Story
                      </a>
                    </li>
                    <li>
                      <a :href="buyhiveHowToBuyLink" class="inline-block py-1 hover:text-green">
                        How to Buy
                      </a>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </li>
        </ul>
      </div>
      <div class="flex items-center text-green">
        <div
          v-if="isUserLoggedIn"
          class="account-area text-dark hover:text-green hover:bg-smoke-100"
          :class="{'border rounded-full border-green' : getUserAuthInfo.role === 'freelancer'}"
          @mouseenter="UserAuthRole()"
          @mouseleave="showUserOptions = false"
        >
          <img v-if="getUserAuthInfo.role === 'freelancer'" src="@/assets/icons/user.svg">
          <i v-else class="text-blue icon-account"></i>
          <span class="ml-2 pt-1" :class="getUserAuthInfo.role === 'freelancer' ? 'text-green' : 'text-blue'">
            {{ getUserAuthInfo.name }}
          </span>
          <transition name="slide-down">
            <div
              v-if="showUserOptions"
              class="user-options top-full bg-white"
              :class="getUserAuthInfo.role === 'freelancer' ? 'mt-2' : 'pt-4'"
            >
              <div
                class="p-3 inset-x-0 top-full rounded-lg border border-dark-b"
                :class="getUserAuthInfo.role === 'freelancer' ? 'bg-theme-light' : 'bg-white'"
              >
                <ul v-if="getUserAuthInfo.role === 'buyer'" class="text-dark">
                  <li>
                    <router-link
                      to="/profile"
                      class="block hover:text-green py-1"
                    >
                      Account Settings
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/profile/my-orders"
                      class="block hover:text-green py-1"
                    >
                      My Orders
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/profile/change-password"
                      class="block hover:text-green py-1"
                    >
                      Change Password
                    </router-link>
                  </li>
                  <li>
                    <div
                      @click="signOut"
                      class="cursor-pointer hover:text-green py-1"
                    >
                      Logout
                    </div>
                  </li>
                </ul>
                <ul v-if="getUserAuthInfo.role === 'freelancer'" class="text-dark">
                  <!-- <li class="leading-6 py-1">Your account will be ready soon!</li>
                  <li class="leading-6 py-1">
                    Any Questions?
                    <router-link
                      to="/contact-us"
                      class="text-blue underline"
                    >
                      Contact Us
                    </router-link>
                  </li> -->
                  <li>
                    <div
                      @click="signOut"
                      class="cursor-pointer hover:text-green py-1 font-semibold"
                    >
                      Logout
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </transition>
        </div>
        <template v-else>
          <button
            class="hidden lg:flex items-center border rounded-full border-blue px-4 py-1 mr-2"
            @click="openSignUpSelection()"
          >
            <span class="text-blue">Register</span>
          </button>
          <button
            class="hidden lg:flex items-center border rounded-full border-green px-4 py-1"
            @click="openLoginSelection(), storeCurrentRoute()"
          >
            <img src="@/assets/icons/user.svg">
            <span class="ml-2">Sign In</span>
          </button>
        </template> 
        <span v-if="!isUserLoggedIn" @click="openLoginSelection()" class="md:hidden mr-2 text-gray-900">Sign In</span>
        <div v-if="getUserAuthInfo.role !== 'freelancer'" class="md:pl-8 relative pr-1 py-1">
          <router-link to="/cart">
            <i class="icon-cart text-green text-2.5xl" />
            <p data-v-4c428599="" class="bg-black text-white rounded-full w-5 h-5 text-center leading-5 text-sm absolute bottom-0 right-0">
              {{ cartProductsLength }}
            </p>
          </router-link>
        </div>
         <button class="lg:hidden pl-3" @click="isMenuNavOpen = true">
          <img src="@/assets/icons/menu.svg">
        </button>
      </div>
    </div>
    <transition name="slide-fade">
      <MenuNav v-if="isMenuNavOpen" @close="isMenuNavOpen=false" />
    </transition>
    <!-- <transition name="fade" >
      <LoginModal v-if="isLoginModalOpen"/>
    </transition>
    <transition name="fade" >
      <LoginSelection v-if="isLoginSelectionModalOpen"/>
    </transition>
    <transition name="fade" >
      <SignUpSelection v-if="isSignupSelectionModalOpen"/>
    </transition> -->
    <transition name="fade" >
      <AlertModal v-if="isAlertModalOpen"/>
    </transition>
    <transition name="fade" >
      <forget-password-modal v-if="isForgetPasswordModalOpen"/>
    </transition>
    <!-- <AuthModal v-if="isAuthModalOpen" /> -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AppLogo from './AppLogo'
import MenuNav from './common/MenuNav'
// import AuthModal from '@/shared/components/auth/AuthModal'
// import LoginModal from '../auth/LoginModal.vue'
// import LoginSelection from '../auth/loginSelection.vue'
// import SignUpSelection from '../auth/signUpSelection.vue'
import AlertModal from '../shared/AlertModal.vue'
import ForgetPasswordModal from '../auth/forgetPasswordModal.vue'

export default {
  name: 'Header',
  data() {
    return {
      isSticky: false,
      isMenuNavOpen: false,
      showUserOptions: false,
      showAboutOptions: false,
      buyhiveHowToBuyLink: process.env.VUE_APP_BUYHIVE_HOW_TO_BUY,
      freelancerURL: process.env.VUE_APP_FREELANCER_HOME_PATH
    }
  },
  components: { AppLogo, MenuNav,   AlertModal, ForgetPasswordModal},
  watch: {
   '$route'(newRoute) {
      this.isMenuNavOpen = false
      if(newRoute.query.authModal && newRoute.query.prev == '/checkout') {
        this.LoginSelectionMode('buyer')
        this.$router.push({name: 'LoginFormv2', query: {prev: '/checkout'}})
      } else if (newRoute.query.authModal) this.$router.push({name: 'LoginSelection'})
      // if (newRoute.query.authModal) this.$router.push({name: 'LoginSelection'})
      if (!this.isUserLoggedIn) {
        const intent = newRoute.query.intent
        if (intent && (intent === 'login')) {
          this.$router.push({name: 'LoginSelection'})
        } else if ( intent && (intent === 'register')) {
          this.$router.push({name: 'SignupSelection'})
        }
      }
    }
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.onScroll)
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    if (!this.isUserLoggedIn) {
      const intent = this.$route.query.intent
      if (intent && (intent === 'login')) {
          this.$router.push({name: 'LoginSelection'})
      } else if ( intent && (intent === 'register')) {
          this.$router.push({name: 'SignupSelection'})
      }
    }
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn',
      'getUserAuthInfo',
      'isAuthModalOpen',
      'getGuestCart',
      'getUserCart',
      'isForgetPasswordModalOpen',
      'isAlertModalOpen',
      'isLoginModalOpen',
      'isLoginSelectionModalOpen',
      'isSignupSelectionModalOpen'
    ]),
    isProfilePage() {
      return true;
    },
    isHomeRoute() {
      return !!( this.$route.name === 'LoginFormv2' || this.$route.name === 'LoginSelection' || this.$route.name === 'SignupSelection' || this.$route.name === 'Register')
    },
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
    cartProductsLength() {
      return this.isUserLoggedIn
        ? this.getUserCart.length
        : this.getGuestCart.length
    },
  },
  methods: {
    ...mapActions ([
      'openAuthModal',
      'logout',
      'openForgetPasswordModal',
      'resetUserCart',
      'setAuthTabModal',
      'openLoginModal',
      'openAlertModal',
      'openSignupSelectionModal',
      'openLoginSelectionModal' ,
      'LoginSelectionMode'
    ]),
    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      this.isSticky = currentScrollPosition > 100 ? true : false
    },
    async signOut() {
      const result = await this.logout()
      this.resetUserCart()
      this.showUserOptions = !result
      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
      }
    },
    openLoginSelection() {
      localStorage.setItem('previousUrl', window.location)
      this.$router.push({name: 'LoginSelection'})
    },
    openSignUpSelection() {
      localStorage.setItem('previousUrl', window.location)
      this.$router.push({name: 'SignupSelection'})
    },
    storeCurrentRoute() {
      if(localStorage.getItem('previousUrl') === null ) {
        localStorage.setItem('previousUrl', window.location.href)
      }
    },
    UserAuthRole() {
      if(this.getUserAuthInfo.role === 'buyer') {
        this.showUserOptions = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-header {
  @apply py-6;
  @screen md { @apply py-8; }
  .account-area {
    @apply hidden;
    @screen lg {
      @apply flex items-center rounded-full px-4 py-1 relative;
      min-width: 165px;
    }
    .user-options {
      @apply z-20 absolute inset-x-0 overflow-hidden duration-200 transition-transform ease-in-out;
      transform-origin: top;
    }
  }
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(100%);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
</style>
